import { PlaceAddressParserOptions, parsePlaceAddress } from './parse-place-address';
import { IPlaceData } from './types';

export function parseGeocodeResult(
  result: google.maps.GeocoderResult,
  options?: PlaceAddressParserOptions
): IPlaceData {
  const { useISOCountry, streetNameFirst } = options ?? {};

  const placeData = {
    coordinates: {
      lat: result.geometry.location.lat(),
      lng: result.geometry.location.lng(),
    },
    address: parsePlaceAddress(result.address_components, {
      useISOCountry,
      streetNameFirst,
    }),
  };

  return placeData;
}
